import React from "react";
import Calendar from "../Calendar/Calendar";
import { DateRangePickerProps, CalendarValue } from "../../../types";
import { parseYMD, formatYMD } from "../../../utils";
import calendarIcon from "../../../assets/icons/calendar.svg";
import "./DateRangePicker.css";

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
  isOpen = false,
  onToggle,
  label = "Date Range",
  className = "",
  style,
}) => {
  const handleCalendarChange = (val: CalendarValue) => {
    if (Array.isArray(val) && val[0] && val[1]) {
      onChange(formatYMD(val[0]), formatYMD(val[1]));
    }
  };

  const todayStr = formatYMD(new Date());
  const startObj = startDate ? parseYMD(startDate) : parseYMD(todayStr);
  const endObj = endDate ? parseYMD(endDate) : parseYMD(todayStr);

  const inputValue =
    startDate && endDate
      ? `${startDate} → ${endDate}`
      : startDate || endDate
        ? `${startDate || "—"} → ${endDate || "—"}`
        : "Select date range";

  return (
    <div className={`attendance-field date-picker-wrapper ${className}`} style={style}>
      {label && <label>{label}</label>}
      <div className="input-with-icon" onClick={onToggle}>
        <input
          type="text"
          readOnly
          value={inputValue}
          className="date-input"
        />
        <img src={calendarIcon} alt="Calendar" className="calendar-icon-img" />
      </div>
      {isOpen && (
        <div className="calendar-popover-dropdown">
          <Calendar
            value={[startObj, endObj]}
            selectRange={true}
            onChange={handleCalendarChange}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
